<template>
  <div v-loading="loading" class="container_box">
    <div class="header_view" v-if="isH5type == true">
      <div class="header">
        <div class="width_50" @click="toRetrn">
          <i class="el-icon-arrow-left"></i>
        </div>
        <p class="hader_text">{{ $route.query.cover_name }}</p>
        <div class="width_50"></div>
      </div>
    </div>
    <div class="mian_view">
      <div class="jxyxjy2023">
        <div v-html="content"></div>
        <!-- <div class="btn" @click="toThirdParty">免费咨询</div> -->
      </div>
      <!-- <Special v-if="whether == true" :id="$route.params.id" />
      <div v-else v-html="content" @click="fn"></div> -->
    </div>
  </div>
</template>

<script>
import infoApi from "@/api/infoH5";
// import Special from "./Special.vue";
export default {
  data() {
    return {
      content: "",
      loading: true,
      whether: false, // 是否是特殊H5单独画页面
      isH5type: false, // 是否是H5过来需要返回
    };
  },
  methods: {
    async getinfoDatalist() {
      let params = {
        coverID: this.$route.params.id,
      };
      const { data } = await infoApi.getCoverById(params);
      if (data.status == 200) {
        this.content = data.data.content;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
      // console.log(data, "资讯数据===",data.data.content);
    },
    // 点击跳转
    fn() {
      window.onAndroidTool.anClick("ksbGuid");
      // window.webkit.messageHandlers.onStartKsbWithKsbGuid.postMessage();
    },
    toRetrn() {
      this.$router.go(-1);
    },
    // 检测是否特殊H5单独画页面
    isWhether() {
      const ID = String(this.$route.params.id);
      const arr = ["40", "41", "44", "48", "54", "57", "70", "90", "93"];
      if (arr.indexOf(ID) >= 0) {
        this.whether = true;
      } else {
        this.whether = false;
      }
      if (this.$route.query.type == "H5") {
        // H5 出现导航栏返回
        this.isH5type = true;
      }
      console.log(this.$route.query.type);
    },
    // 跳转
    toThirdParty(type) {
      //判断访问终端
      var browser = {
        versions: (function () {
          var u = navigator.userAgent,
            app = navigator.appVersion;
          return {
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == " qq", //是否QQ
          };
        })(),
        language: (
          navigator.browserLanguage || navigator.language
        ).toLowerCase(),
      };
      // 跳转客服
      if (browser.versions.iPhone || browser.versions.ios) {
        //ios系统
        window.webkit.messageHandlers.jumpService.postMessage("jumpService"); // 苹果
      } else if (browser.versions.android) {
        //安卓系统
        if (type === "Android") {
          // 安卓跳转领取优惠券
          // console.log(this.id, "ID", this.$route.params.id);
          window.onAndroidTool.getCoupon(this.$route.params.id); // 安卓
        } else {
          window.onAndroidTool.bannerPoint(); // 安卓埋点
          window.onAndroidTool.startQiYuServiceAndInfo("", ""); // 安卓
        }
      }
    },
  },
  components: {
    // Special,
  },
  created() {
    this.getinfoDatalist();
    this.isWhether();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-loading-spinner .circular {
  // height: 630px !important;
}
.container_box {
  width: 100%;
  // height: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.header_view {
  flex: 0 0 80px;
  width: 100%;
  background: #ffff;
  padding: 0px 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  .header {
    height: 80px;
    display: flex;
    align-items: center;
    text-align: center;
    box-sizing: border-box;
    .width_50 {
      min-width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon-31fanhui1 {
        font-size: 60px;
      }
      i {
        font-size: 40px;
      }
    }
    .hader_text {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      text-align: center;
      width: 100%;
      letter-spacing: 1px;
    }
  }
}
.mian_view {
  // padding: 10px;
  flex: 1;
  position: relative;
}
.jxyxjy2023 {
  // position: relative;
  overflow-y: auto;
  height: auto;
  background: #195bb7;
  margin-bottom: 85px;
  > img {
    vertical-align: top;
    width: 100%;
  }
  .btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    height: 80px /* 60/50 */;
    line-height: 80px;
    font-size: 24px;
    // font-weight: bold;
    letter-spacing: 4px;
    // border: 1px solid #000;
    // background: rgba(255, 0, 0, 0.361);
    background: #46A7EC;
    color: #fff;
    // opacity: 0;
  }
}
</style>